import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit'
import overlayFactory from 'react-bootstrap-table2-overlay'
import paginationFactory from 'react-bootstrap-table2-paginator'
import filterFactory from 'react-bootstrap-table2-filter'
import { Spinner } from 'react-bootstrap'

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css'

function llenarArray (cpaAbandonada) {
  const filasgrilla = []
  cpaAbandonada.filas.map(control => (
    filasgrilla.push({
      fechaDeIngreso: `${new Date(control.fechaDeIngreso).toLocaleString('es-AR')}`,
      fechaDeAbandono: `${new Date(control.fechaDeAbandono).toLocaleString('es-AR')}`,
      numero: control.numero,
      claveCereal: control.claveCereal,
      cereal: control.cereal,
      cerealVariedad: control.cerealVariedad,
      exportador: `${control.exportador} - ${control.cuitExportador}`,
      titularDeCupo: `${control.titularDeCupo} - ${control.cuitTitularDeCupo}`,
      remitenteComercial: `${(control.remitenteComercial) ? control.remitenteComercial : ''} - ${(control.cuitRemitenteComercial) ? control.cuitRemitenteComercial : ''}`,
      corredorComprador: `${control.corredorComprador} - ${control.cuitCorredorComprador}`,
      vendedor: `${control.vendedor} - ${control.cuitVendedor}`,
      camion: control.camion,
      codigoCupo: control.codigoCupo,
      motivoAbandono: control.motivoAbandono
    })
  )
  )
  return filasgrilla
}

class CpaAbandonada extends Component {
  constructor (props) {
    super(props)
    this.columns = [
      { dataField: 'fechaDeIngreso', text: 'Ingreso', sort: true },
      { dataField: 'fechaDeAbandono', text: 'Abandono', sort: true },
      { dataField: 'numero', text: 'CP', sort: true },
      { dataField: 'cereal', text: 'Cereal', sort: true },
      { dataField: 'cerealVariedad', text: 'Variedad' },
      { dataField: 'exportador', text: 'Exportador', sort: true },
      { dataField: 'titularDeCupo', text: 'Titular Cupo', sort: true },
      { dataField: 'remitenteComercial', text: 'Remitente Comercial', sort: true },
      { dataField: 'corredorComprador', text: 'Corredor Comprador', sort: true },
      { dataField: 'vendedor', text: 'Representante Entregador', sort: true },
      { dataField: 'camion', text: 'Camion', sort: true },
      { dataField: 'codigoCupo', text: 'Codigo Cupo' },
      { dataField: 'motivoAbandono', text: 'Motivo de Abandono' }
    ]
  }

  componentDidMount () {
    // Llamar a la funcion que trae los datos del BE
    this.props.obtenerDatosCpaAbandonada()
  }

  componentWillUpdate () {
  }

  render () {
    const {
      cpaAbandonada
    } = this.props
    var filas = []
    // Variables para la grilla
    const { SearchBar } = Search
    const { ExportCSVButton } = CSVExport
    const defaultSorted = [{
      dataField: 'fechaDeIngreso',
      order: 'desc'
    }]

    if (cpaAbandonada !== null && cpaAbandonada.filas_procesadas > 0) {
      filas = llenarArray(cpaAbandonada)
    }
    return (
      <div>
        <h1>Listado de Carta de Porte Abandonadas</h1>
        <br />
        {(cpaAbandonada !== null) && <ToolkitProvider
          keyField='numero'
          data={filas}
          columns={this.columns}
          defaultSorted={defaultSorted}
          pagination={paginationFactory()}
          filter={filterFactory()}
          loading
          overlay={overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.3)' })}
          noDataIndication='No hay informacion para mostrar.'
          search
          exportCSV
          striped
          hover
          condensed
          bootstrap4
        >
          {
            props => (
              <div>
                <SearchBar
                  {...props.searchProps}
                  className='custome-search-field'
                  style={{ color: 'black', background: 'white' }}
                  delay={50}
                  placeholder='Buscar...'
                />
                <BootstrapTable
                  {...props.baseProps}
                  striped
                  hover
                  condensed
                  bootstrap4
                  headerClasses='react-bootstrap-table-titulos'
                  rowClasses='react-bootstrap-table-filas'
                />
                <hr />
                <ExportCSVButton {...props.csvProps}>Exportar en CSV</ExportCSVButton>
              </div>
            )
          }
        </ToolkitProvider>}
        {(cpaAbandonada === null) && <span><Spinner animation='border' variant='danger' /></span>}
        <br />
      </div>
    )
  }
}
export default CpaAbandonada
